import { BookingDiaryEventCtrl } from './booking-diary.event.ajs';
import { JsonService }           from '../../app-lite/core/services/json.service';

export class BookingDiaryWeekEventCtrl extends BookingDiaryEventCtrl implements ng.IComponentController {
  event : any;

  constructor (
    $rootScope: ng.IRootScopeService,
    jsonApi   : JsonService
  ) {
    super($rootScope, jsonApi);
  }
}
